import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Paper, InputBase } from '@material-ui/core'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useDispatch } from 'react-redux'
import { CreatorsAnchors } from '../../../../store/ducks/anchors'

import Header from '../../../../layout/Header'
import Subheader from '../../../../layout/Subheader'
import Loading from '../../../../components/Loading'

import { formatDateTimeToRender } from '../../../../utils/functions'

import GridAncorasLojasCodes from '../../Anchor/components/GridAncorasLojasCodigos'

import useStyles from './style'

function Render ({
  inputs,
  getAncoras,
  getLoading,
  lastGrid,
  getAncorasLojasCodigos,
  ancorasLojasCodigosRef,
  findAllAncorasLojasCodigos,
  getAncorasLoadingCodigos,
  ancoralojaid
}) {
  const classes = useStyles()
  const dispatch = useDispatch()

  return (
    <div className={classes.root}>
      <Header />
      <Subheader title="Visualizando lojas da rede: " back={false} subanchor={true} />
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {getLoading
            ? (<Loading />)
            : (
              <>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.summary}
            >
              <Typography className={classes.heading}>Informações</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container>
                <Grid item xs={12}>

                  <label className={classes.label}>Nome</label>
                  <Paper className={classes.large} elevation={0}>
                    <InputBase
                      style={{ textTransform: 'uppercase !important' }}
                      min
                      className={classes.input}
                      classes={{ input: classes.inputText }}
                      placeholder="Nome"
                      value={inputs.nome}
                      required
                      name="nome"
                      readOnly
                      onBlur
                      inputProps={{
                        minLength: 3,
                        maxLength: 100,
                        pattern: '[A-Za-z0-9 ]*',
                        title: 'Não utilize acentos nem caracteres especiais'
                      }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Status</label>
                  <Paper className={classes.medium} elevation={0}>
                  <select
                      className={classes.input}
                      required
                      value={inputs.status}
                      name="status"
                      disabled
                    >
                      <option value="">Selecione o status</option>
                      <option value="Ativo">Ativo</option>
                      <option value="Inativo">Inativo</option>
                    </select>
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                <label className={classes.label}>Rede</label>
                  <Paper className={classes.medium} elevation={0}>
                  <select
                      className={classes.input}
                      required
                      value={inputs.ancoraId}
                      name="ancoraId"
                      disabled
                      readOnly
                    >
                      <option value="">Selecione uma rede</option>
                      {getAncoras.map(ancora => (
                        <option key={ancora.ancoraId} value={ancora.ancoraId}>{ancora.razaoSocial}</option>
                      ))}
                    </select>
                  </Paper>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

<Accordion defaultExpanded>
<AccordionSummary
  expandIcon={<ExpandMoreIcon />}
  aria-controls="panel1a-content"
  id="panel1a-header"
  className={classes.summary}
>
  <Typography className={classes.heading}>Dados do Registro</Typography>
</AccordionSummary>
<AccordionDetails className={classes.details}>
  <Grid container>

  <Grid item xs={6}>
      <label className={classes.label}>Data de Registro</label>
      <Paper className={classes.medium} elevation={0}>
        <InputBase
          className={classes.input}
          value={inputs.dataRegistro && formatDateTimeToRender(inputs.dataRegistro)}
          readOnly
          placeholder="Data do Registro"
        />
      </Paper>
    </Grid>

    <Grid item xs={6}>
      <label className={classes.label}>Data da Atualização</label>
      <Paper className={classes.medium} elevation={0}>
        <InputBase
          className={classes.input}
          value={inputs.dataAtualizacao ? formatDateTimeToRender(inputs.dataAtualizacao) : ''}
          readOnly
          placeholder="Data da Atualização"
        />
      </Paper>
    </Grid>

  </Grid>
</AccordionDetails>
</Accordion>

<Accordion
        onChange={(event, expanded) => {
          if (!expanded) {
            dispatch(CreatorsAnchors.changeModal({ anchor: 'ancoras-contatos' }))
            dispatch(CreatorsAnchors.changeFilter({ anchor: 'ancoras-contatos', filter: null }))
          }
          if (expanded && !getAncorasLojasCodigos.length) {
            findAllAncorasLojasCodigos()
          }
        }}
        defaultExpanded={lastGrid === 'ancoras-lojas-codigos'}
        ref={ancorasLojasCodigosRef}
        className={classes.accordionRoot}
        >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.summary}
        >
          <Typography className={classes.heading}>Lojas Códigos</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <Grid container>
            {getAncorasLoadingCodigos
              ? (<Loading />)
              : (
                <GridAncorasLojasCodes
                  ancoraLojaId={ancoralojaid}
                  visualize={true}
                  findAllAncorasLojasCodigos={findAllAncorasLojasCodigos}
                  getAncorasLojasCodigos={getAncorasLojasCodigos}/>
                )}
          </Grid>
        </AccordionDetails>
        </Accordion>

</>
              )}
        </div>

      </div>
    </div>
  )
}

export default Render
